import React from 'react';
import PropTypes from 'prop-types';
import Typography from "../Typography";
import styles from "./styles.module.scss";

const LineThrough = ({children, variant, className}) => {
    return (
        <div className={className}>
            <Typography variant={variant} className={styles.lineThrough}>
                <span>{children}</span>
            </Typography>
        </div>
    );
};

LineThrough.propTypes = {
    variant: PropTypes.string,
    className: PropTypes.string,
};

export default LineThrough;
